<ui-dialog [dialogConfig]="dialogConfig">
    <ng-container *cdkPortalOutlet></ng-container>
</ui-dialog>
